exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nth[data-v-75cbcb6a],\ntd[data-v-75cbcb6a] {\n  padding-bottom: 1rem;\n  padding-top: 1rem;\n  border-bottom: 1px solid silver;\n}\n.min-height[data-v-75cbcb6a] {\n  height: 30rem;\n}\n.min-height-1[data-v-75cbcb6a] {\n  height: 15rem;\n}\n", ""]);

// exports
